import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-application',
  templateUrl: './delete-application.component.html',
  styleUrls: ['./delete-application.component.scss']
})
export class DeleteApplicationComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<DeleteApplicationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string, content: string },
    ) {}
  ngOnInit(): void {
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit(){
    this.dialog.close(true);
  }

}
